import api from './api';
import { handleApiError } from '../utils/apiErrors';

export const addressService = {
    getAddresses: async (userId) => {
        try {
            const response = await api.get(`/addresses/user/${userId}`);
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    createAddress: async (data) => {
        try {
            const response = await api.post('/addresses', data);
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    updateAddress: async (id, data) => {
        try {
            const response = await api.put(`/addresses/${id}`, data);
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    deleteAddress: async (id) => {
        try {
            const response = await api.delete(`/addresses/${id}`);
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    }
};
